import React, { useState } from "react";
import {
  AcademicCapIcon,
  ClockIcon,
  BookOpenIcon,
  UserGroupIcon,
  GlobeAltIcon,
  LockClosedIcon,
  PlayIcon,
} from "@heroicons/react/solid";

const CourseDetails = () => {
  const [activeTab, setActiveTab] = useState("overview");
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = (section) => {
    setExpandedSection(expandedSection === section ? null : section);
  };

  return (
    <div className="bg-grayLight text-gray-900">
      {/* Header Section */}
      <div
        className="relative bg-cover bg-center h-64 md:h-72 lg:h-80"
        style={{
          backgroundImage:
            "url('https://via.placeholder.com/1920x500?text=Course+Details+Header')",
        }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center text-white text-center">
          <h1 className="text-2xl md:text-4xl font-bold">Java Programming Masterclass</h1>
          <p className="mt-2 text-sm md:text-base">
            <a href="/" className="hover:underline">
              Home
            </a>{" "}
            / Pages / Course Details
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 py-8 md:py-12 px-4">
        {/* Left Column */}
        <div className="lg:col-span-2">
          {/* Metadata */}
          <h2 className="text-xl md:text-3xl font-bold mb-4 md:mb-6">
            Java Programming Masterclass with Professional Author
          </h2>
          <div className="flex flex-col md:flex-row md:items-center md:space-x-4 text-gray-600 mb-4 md:mb-6 space-y-2 md:space-y-0">
            <p>
              <strong>Teacher:</strong> John Kanel
            </p>
            <p>
              <strong>Category:</strong> Mathematics
            </p>
            <p>
              <strong>Last Update:</strong> January 24, 2021
            </p>
          </div>

          {/* Tabs */}
          <div className="flex space-x-4 md:space-x-6 border-b border-gray-200 pb-4 mb-6">
            {["overview", "curriculum", "advisor", "reviews"].map((tab) => (
              <button
                key={tab}
                className={`pb-2 font-bold text-sm md:text-base ${
                  activeTab === tab
                    ? "text-primary border-b-2 border-primary"
                    : "text-gray-600 hover:text-primary"
                }`}
                onClick={() => setActiveTab(tab)}
              >
                {tab.charAt(0).toUpperCase() + tab.slice(1)}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div>
            {activeTab === "overview" && (
              <div>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-6">
                  Placing assured be if removed it besides on. Far shed each
                  high read are men over day. Afraid we praise lively he suffer
                  family estate is.
                </p>
              </div>
            )}

            {activeTab === "curriculum" && (
              <div className="space-y-4">
                {[
                  { title: "Java Programming", lectures: ["Introduction of Java", "Basic Development"] },
                  { title: "PHP Programming", lectures: [] },
                  { title: "Python Learning", lectures: [] },
                ].map((section, index) => (
                  <div
                    key={index}
                    className={`border rounded-lg ${
                      expandedSection === index
                        ? "border-primary"
                        : "border-gray-200"
                    }`}
                  >
                    <div
                      className="p-4 flex justify-between items-center cursor-pointer"
                      onClick={() => toggleSection(index)}
                    >
                      <h3 className="font-bold text-sm md:text-lg">{section.title}</h3>
                      <span
                        className={`transform ${
                          expandedSection === index ? "rotate-180" : ""
                        }`}
                      >
                        ▼
                      </span>
                    </div>
                    {expandedSection === index && (
                      <div className="p-4 space-y-4">
                        {section.lectures.length > 0 ? (
                          section.lectures.map((lecture, i) => (
                            <div
                              key={i}
                              className="flex justify-between items-center text-sm md:text-base"
                            >
                              <span>
                                {i + 1 < 10 ? `0${i + 1}` : i + 1}. {lecture}
                              </span>
                              <span className="flex items-center space-x-2 text-gray-500">
                                {i === 0 ? (
                                  <PlayIcon className="w-4 h-4 md:w-5 md:h-5 text-primary" />
                                ) : (
                                  <LockClosedIcon className="w-4 h-4 md:w-5 md:h-5" />
                                )}
                                <span>{i === 0 ? "19 minutes" : "11 minutes"}</span>
                              </span>
                            </div>
                          ))
                        ) : (
                          <p>No lectures available</p>
                        )}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {activeTab === "advisor" && (
              <div>
                <h3 className="text-lg md:text-xl font-bold mb-4">Advisor</h3>
                <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                  Your advisor, <strong>John Kanel</strong>, is a professional
                  software engineer with 10+ years of experience.
                </p>
              </div>
            )}

            {activeTab === "reviews" && (
              <div>
                <h3 className="text-lg md:text-xl font-bold mb-4">Reviews</h3>
                <div className="space-y-4">
                  <div className="bg-white p-4 rounded-lg shadow">
                    <p className="text-sm text-gray-600">⭐⭐⭐⭐⭐</p>
                    <p className="text-sm md:text-base text-gray-700">
                      "This course is amazing!" - <strong>Jane Doe</strong>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Right Column */}
        <div className="bg-white shadow-lg rounded-lg p-4 md:p-6">
          {/* Price */}
          <div className="text-2xl md:text-4xl font-bold text-primary mb-4">$32</div>
          <div className="flex items-center text-sm md:text-base text-gray-500 mb-6">
            ⭐ 4.8 (867 Reviews)
          </div>

          {/* Course Details */}
          <ul className="space-y-3 text-sm md:text-base text-gray-600 mb-6">
            <li className="flex items-center">
              <BookOpenIcon className="w-5 h-5 md:w-6 md:h-6 text-primary mr-2" />
              <strong>Lectures:</strong> 12
            </li>
            <li className="flex items-center">
              <ClockIcon className="w-5 h-5 md:w-6 md:h-6 text-primary mr-2" />
              <strong>Duration:</strong> 7.5 Hours
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;